import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import {
    DropdownToggle,
    Dropdown
} from "../../ui/dropdown/dropdown";
import {
    Avatar,
    AvatarInitial,
} from "../../ui/avatar/avatar"
import {
    StyledDropMenu,
    StyledAuthorName,
    StyledAuthorRole,
    StyledDropItem,
    StyledAvatar,
    StyledUsername,
} from "./style";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Link } from 'react-router-dom';
import { logOut, getStoredMemberId } from "../../../utils/auth";
import { Typography } from '@mui/material';
import { getMyUserDetailList } from '../../../redux/actions/memberAction';
import { RootState } from '../../../redux/store';
import ChangePasswordModal from '../../ChangePasswordModal';

const roles = localStorage.getItem('roles');
const userNameFromStorage = localStorage.getItem('userName');

const formatUserName = (userName: string | null): string => {
    if (!userName) return '';
    return userName
        .replace(/['"]/g, '')
        .split('.')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

export { logOut } from "../../../utils/auth";

const getInitials = (myUserDetailList: any) => {
    if (!myUserDetailList) return 'RDC';
    
    if (typeof myUserDetailList === 'object' && myUserDetailList !== null && !Array.isArray(myUserDetailList)) {
        const avatar = (myUserDetailList as any)?.avatar;
        if (avatar) {
            return avatar;
        }

        const userName = (myUserDetailList as any)?.userName ?? (myUserDetailList as any)?.data?.userName;
        if (userName) {
            return userName
                .replace(/['"]/g, '')
                .split('.')
                .map((word: string) => word.charAt(0).toUpperCase())
                .join('');
        }
    }
    
    return 'RDC';
};

const getPhotoUrl = (myUserDetailList: any): string | null => {
    if (
        !myUserDetailList ||
        typeof myUserDetailList !== 'object' ||
        Array.isArray(myUserDetailList)
    ) {
        return null;
    }

    return (
        (myUserDetailList as any)?.photoUrl ??
        (myUserDetailList as any)?.data?.photoUrl ??
        null
    );
};

const ProfileDropdown: React.FC = () => {
    const dispatch = useDispatch();
    const [passwordModalOpen, setPasswordModalOpen] = useState(false);

    const { myUserDetailList } = useSelector(
        (state: RootState) => state.myUserDetail
    );

    useEffect(() => {
        const memberId = getStoredMemberId();

        const isEmpty = 
            !myUserDetailList || 
            (Array.isArray(myUserDetailList) && myUserDetailList.length === 0) ||
            (typeof myUserDetailList === 'object' && !Array.isArray(myUserDetailList) && Object.keys(myUserDetailList).length === 0);

        if (isEmpty && memberId) {
            dispatch(getMyUserDetailList({ state: { memberId } }));
        }
    }, [myUserDetailList, dispatch]);

    const getUserRole = () => {
        if (!myUserDetailList) {
            return '';
        }

        if (typeof myUserDetailList === 'object' && myUserDetailList !== null && !Array.isArray(myUserDetailList)) {
            const role = (myUserDetailList as any)?.Role;
            if (role) {
                return role;
            }

            const departmentList = (myUserDetailList as any)?.departmentList;
            if (Array.isArray(departmentList) && departmentList.length > 0) {
                const tasks: string[] = [];
                departmentList.forEach((department: any) => {
                    if (department.task && !tasks.includes(department.task)) {
                        tasks.push(department.task);
                    }
                });
                if (tasks.length > 0) {
                    return tasks.join(', ');
                }
            }
        }

        return '';
    };

    const getUserName = () => {
        if (!myUserDetailList) {
            return formatUserName(userNameFromStorage);
        }

        if (typeof myUserDetailList === 'object' && myUserDetailList !== null && !Array.isArray(myUserDetailList)) {
            const nameSurname = (myUserDetailList as any)?.nameSurname;
            
            if (nameSurname) {
                return nameSurname;
            }

            const nameSurnameFromData = (myUserDetailList as any)?.data?.nameSurname;
            if (nameSurnameFromData) {
                return nameSurnameFromData;
            }
        }

        return formatUserName(userNameFromStorage);
    };

    const initials = getInitials(myUserDetailList);
    const photoUrl = getPhotoUrl(myUserDetailList);

    return (
        <>
        <Dropdown direction="down" className="dropdown-profile">
            <DropdownToggle variant="texted">
                <StyledAvatar size="sm">
                    {photoUrl ? (
                        <img src={photoUrl} alt={getUserName()} />
                    ) : (
                        <AvatarInitial>{initials}</AvatarInitial>
                    )}
                </StyledAvatar>
                <StyledUsername>{getUserName()}</StyledUsername>
                <ArrowDropDownIcon sx={{ color: 'white', ml: 3 }} />
            </DropdownToggle>
            <StyledDropMenu>
                <Avatar size="lg">
                    {photoUrl ? (
                        <img src={photoUrl} alt={getUserName()} />
                    ) : (
                        <AvatarInitial>{initials}</AvatarInitial>
                    )}
                </Avatar>

                <StyledAuthorName>{getUserName()}</StyledAuthorName>
                <StyledAuthorRole>{getUserRole()}</StyledAuthorRole>

                <StyledDropItem path="#" mt="10px">
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            setPasswordModalOpen(true);
                        }}
                        style={{ fontSize: '14px', padding: '6px 20px', display: 'flex', alignItems: 'center' }}
                    >
                        <VpnKeyIcon style={{ marginRight: '8px' }} />
                        PAROLA DEĞİŞTİR
                    </button>
                </StyledDropItem>

                <StyledDropItem path="/login" mt="10px">
                    <button onClick={logOut} style={{ fontSize: '14px', padding: '6px 20px', display: 'flex', alignItems: 'center' }}>
                        <ExitToAppIcon style={{ marginRight: '8px' }} />
                        ÇIKIŞ YAP
                    </button>
                </StyledDropItem>

                <Link to="/version-notes" style={{ textDecoration: 'none' }}>
                    <Typography
                        variant="body2"
                        sx={{ color: 'black', fontWeight: 500, cursor: 'pointer', userSelect: 'none', marginTop: '10px' }}
                    >
                        v.1.0.3
                    </Typography>
                </Link>
            </StyledDropMenu>
        </Dropdown>
        <ChangePasswordModal
            open={passwordModalOpen}
            onClose={() => setPasswordModalOpen(false)}
        />
        </>
    );
};

export default ProfileDropdown;
